import { Stack, TextField } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { LoadingButton } from "../../../shared";


const fieldSx = {
  width: { xs: "100%", sm: 250 },
  "& .MuiOutlinedInput-root": {
    height: 42,
    borderRadius: "8px",
    "& fieldset": { borderColor: "#808080" },
  },
};

// The store field is only rendered when `storeOptions` is given (super admin)
export const SalesVatReportFilterSection = ({
  values,
  errors,
  maxMonth,
  storeOptions = null,
  isExporting,
  onMonthChange,
  onStoreChange,
  onGenerate,
}) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      gap="16px"
      alignItems="flex-start"
      sx={{
        // Spans the full width under the page header
        mx: "-24px",
        mt: "-16px",
        px: "32px",
        pt: "16px",
        pb: "24px",
        bgcolor: "background.paper",
      }}
    >
      <InputControl
        type="datePicker"
        name="month"
        label="Month"
        views={["year", "month"]}
        openTo="month"
        inputFormat="MMMM yyyy"
        value={values.month}
        maxDate={maxMonth}
        onChange={onMonthChange}
        error={Boolean(errors.month)}
        helperText={errors.month}
        onKeyDown={(e) => {
          if (e.key !== "Tab") e.preventDefault();
        }}
        sx={fieldSx}
      />
      {storeOptions && (
        <InputControl
          type="dropdown"
          name="store"
          disableClearable
          options={storeOptions}
          value={values.store}
          onChange={onStoreChange}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          sx={fieldSx}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Store"
              placeholder="Select Store"
              error={Boolean(errors.store)}
              helperText={errors.store}
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
            />
          )}
        />
      )}
      <LoadingButton
        variant="contained"
        loading={isExporting}
        onClick={onGenerate}
        sx={{
          ml: "auto",
          mt: "-3px",
        }}
      >
        Generate
      </LoadingButton>
    </Stack>
  );
};
